import React from "react";
import { Link } from "react-router-dom";
import { HiArrowRight } from "react-icons/hi";
import { brand } from "../data/siteData"; // Assuming you have a videos export
import useScrollReveal from "../hooks/useScrollReveal";
import "./Hero.css";

export default function Hero() {
  const sectionRef = useScrollReveal(({ gsap, el }) => {
    gsap.from(el.querySelectorAll(".hero__eyebrow, .hero__title, .hero__supporting, .hero__ctas"), {
      y: 24,
      opacity: 0,
      duration: 0.8,
      stagger: 0.1,
      ease: "power3.out",
    });

    // Gentle parallax: the video drifts slower than scroll, the disc faster.
    gsap.to(el.querySelector(".hero__video"), {
      yPercent: 12,
      ease: "none",
      scrollTrigger: {
        trigger: el,
        start: "top top",
        end: "bottom top",
        scrub: 0.6,
      },
    });
    gsap.to(el.querySelector(".hero__disc"), {
      yPercent: -18,
      ease: "none",
      scrollTrigger: {
        trigger: el,
        start: "top top",
        end: "bottom top",
        scrub: 0.6,
      },
    });
  }, []);

  return (
    <section className="hero" ref={sectionRef}>
      <div className="hero__backdrop" aria-hidden="true" />
      <video
        className="hero__video"
        src="/assets/video.mp4"
        autoPlay
        loop
        muted
        playsInline
        aria-hidden="true"
      />
      <div className="hero__disc" aria-hidden="true" />

      <div className="container hero__content">
        <span className="eyebrow hero__eyebrow">Solar Engineering Solutions</span>
        <h1 className="hero__title">
          {brand.name}
          <span className="hero__title-line accent-text">{brand.tagline}</span>
        </h1>
        <p className="hero__supporting">{brand.supporting}</p>
        <div className="hero__ctas">
          <Link to="/contact" className="btn btn-primary">
            Contact Now <HiArrowRight />
          </Link>
          <Link to="/services" className="btn btn-outline">
            Our Products
          </Link>
        </div>
      </div>

      <div className="hero__frame-line" aria-hidden="true" />
    </section>
  );
}